// src/components/Gallery/CategorySeparator.js
import React from 'react';

const CategorySeparator = ({ category }) => {
  return (
    <div className="portfolio-category-separator">
      <h2 className="portfolio-category-title">{category.title}</h2>
      <div className="portfolio-category-subtitle">{category.subtitle}</div>
      <p className="portfolio-category-description">{category.description}</p>
      <div className="portfolio-category-line"></div>
    </div>
  );
};

export default CategorySeparator;